import React from 'react';
import { apiHost } from '../../../config';
import Img from '../Img';
import { useStatsig } from '../hooks/useStatsig';
import styles from '../../pages/LoginPage/Login/login.scss';

const TennisAustraliaLogin = ({ showUpdatedButton = false, 'data-testid': dataTestId }) => {
    const { checkGate, featureGates } = useStatsig();
    const isTennisAustraliaLoginActive = checkGate(featureGates.TENNIS_AUSTRALIA_OAUTH);

    const onSubmitTA = () => {
        window.location.href = `${apiHost}/v1/oauth/ta/initiate?platform=web&source=internal&flow=login`;
    };

    if (!isTennisAustraliaLoginActive) return null;

    return (
        showUpdatedButton ? (
            <button
                type="button"
                onClick={onSubmitTA}
                className={styles.magicLinkSocialButton}
                data-testid={dataTestId}
            >
                <Img src="/img/v4/icon-ta-login.svg" />
            </button>
        ) : (
            <button
                type="button"
                className={`btn btn-primary btn-block mb16 btn-xl`}
                onClick={onSubmitTA}
                data-testid={dataTestId}
            >
                <div className="d-flex jcc">
                    <Img src="/img/partners/tennis-australia-login.svg" />
                    <div className="ml-2 text-uppercase" data-testid={dataTestId && `${dataTestId}.text`}>Tennis Australia</div>
                </div>
            </button>
        )
    );
};

export default TennisAustraliaLogin;
